module.exports = __webpack_public_path__ + "static/media/mobileDevice_en.98ed8e65.png";